
export const movieGenres = ["Akcja", "Komedia", "Biograficzne", "Dramat", "Komedia romantyczna","Science fiction", "Thriller", "Dla dzieci"];
